import { useTheme } from '@/contexts/ThemeContext';
import { FiSun, FiMoon } from 'react-icons/fi';
import './ThemeToggle.css';

export function ThemeToggle() {
  const { theme, setTheme, effectiveTheme } = useTheme();

  const handleToggle = () => {
    // Ciclar entre: auto -> light -> dark -> auto
    if (theme === 'auto') {
      setTheme('light');
    } else if (theme === 'light') {
      setTheme('dark');
    } else {
      setTheme('auto');
    }
  };

  const getIcon = () => {
    if (theme === 'auto') {
      return effectiveTheme === 'dark' ? <FiMoon size={20} /> : <FiSun size={20} />;
    }
    return theme === 'dark' ? <FiMoon size={20} /> : <FiSun size={20} />;
  };

  const getLabel = () => {
    if (theme === 'auto') {
      return `Auto (${effectiveTheme === 'dark' ? 'Oscuro' : 'Claro'})`;
    }
    return theme === 'dark' ? 'Oscuro' : 'Claro';
  };

  return (
    <button
      className="theme-toggle"
      onClick={handleToggle}
      aria-label={`Cambiar tema. Actual: ${getLabel()}`}
      title={`Tema: ${getLabel()}`}
    >
      {getIcon()}
      <span className="theme-toggle-label">{getLabel()}</span>
    </button>
  );
}
